import React from 'react';
import { Empty } from 'antd';
import {
  Body,
  Container,
  EventNameValueWrapper,
  Footer,
  FooterTitle,
  Header,
  Name,
  Value,
} from '@src/emp-3.0/components/MappedEventDetail/styled';
import Icon from '@ant-design/icons';
import ViewDetailIcon from '@icons/emp/view_detial.svg';
import { StyledAntButton } from '@src/emp-3.0/components/MappedEventDetail/QuickLook/styled';
import { IMappedEventQuickLook } from '@src/emp-3.0/components/MappedEventDetail/QuickLook/MappedEventQuickLook';
import { getEmptyRuleGroupInAPIForm } from '@src/emp-3.0/utils';

export interface IRawEventQuickLook extends IMappedEventQuickLook {
  name?: string;
}

const RawEventQuickLook: React.FC<IRawEventQuickLook> = ({
  id,
  name,
  footer,
  searchText,
  okButtonProps,
  noButtonProps,
}) => {
  if (!name) return <Empty description="Data Not Found" />;

  const renderFooter = () => {
    return null;
    if (footer === null) {
      return null;
    }

    if (footer === undefined) {
      return (
        <Footer>
          <FooterTitle>Would you like to add more constraints to the raw event?</FooterTitle>
          <StyledAntButton
            type="link"
            {...okButtonProps}
            onClick={() => {
              const emptyRule = getEmptyRuleGroupInAPIForm();
              emptyRule.value = [name];
              okButtonProps?.onClick?.({
                event_name: name,
                event_category: 'Custom',
                rules: [[emptyRule]],
              });
            }}
          >
            Yes, create a rule
          </StyledAntButton>
          <StyledAntButton
            type="link"
            {...noButtonProps}
            onClick={() => {
              noButtonProps?.onClick?.(id);
            }}
          >
            No, use directly
          </StyledAntButton>
        </Footer>
      );
    }

    return footer;
  };

  return (
    <Container>
      {/* <Header style={{ borderBottom: '1px solid #F0F0F0' }}>
        <Icon component={ViewDetailIcon} />
        <span>Quick Look</span>
      </Header> */}
      <Body style={{ padding: '8px 16px' }}>
        <div style={{ marginBottom: '8px' }}>
          <EventNameValueWrapper>
            {/* <Name style={{ color: 'rgba(0, 0, 0, 0.45)' }}>Mapped Event :</Name> */}
            <Value>No Mapping rule.</Value>
          </EventNameValueWrapper>
          {/* <EventNameValueWrapper>
            <Name style={{ color: 'rgba(0, 0, 0, 0.45)' }}>Event Type :</Name>
            <Value>Raw Event</Value>
          </EventNameValueWrapper> */}
        </div>
      </Body>
      {renderFooter()}
    </Container>
  );
};

export default RawEventQuickLook;
